import { makeStyles } from 'tss-react/mui';
import { spacing } from '../../styles/jss/variables';
const useStyles = makeStyles()((theme, { backgroundColour, accentColour, textColour }) => {
    return {
        outerWrapper: {
            borderRadius: 8,
            paddingLeft: spacing.xs,
            paddingRight: spacing.xs,
            backgroundColor: accentColour || undefined,
            [theme.breakpoints.up('md')]: {
                paddingLeft: 12,
                paddingRight: 12,
            },
        },
        // Inner div: background colour + all content
        innerWrapper: {
            borderRadius: 8,
            padding: spacing.small,
            display: 'flex',
            flexDirection: 'column',
            gap: spacing.small,
            backgroundColor: backgroundColour || undefined,
            color: textColour || undefined,
            [theme.breakpoints.up('md')]: {
                flexDirection: 'row',
                alignItems: 'center',
                padding: spacing.medium,
                gap: 0,
            },
        },
        quoteSection: {
            display: 'flex',
            flexDirection: 'row',
            gap: spacing.xs,
            flex: '1 0 0',
            alignItems: 'flex-start',
            minWidth: 0,
            [theme.breakpoints.up('md')]: {
                marginRight: spacing.medium,
            },
        },
        quoteIcon: {
            flexShrink: 0,
            transform: 'rotate(180deg)',
            color: 'inherit',
            '& .material-icons': {
                fontSize: 48,
                [theme.breakpoints.up('md')]: {
                    fontSize: 60,
                },
            },
        },
        // Apply typography from RawHtml (overrides default <p> tag styles) — Small
        quoteTextSmall: Object.assign(Object.assign({}, theme.typography.medium_bold), { wordBreak: 'break-word', '& p': Object.assign(Object.assign({}, theme.typography.medium_bold), { margin: '0 !important', padding: '0 !important' }), [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.large_bold), { '& p': Object.assign(Object.assign({}, theme.typography.large_bold), { margin: '0 !important', padding: '0 !important' }) }) }),
        quoteTextLarge: Object.assign(Object.assign({}, theme.typography.large_bold), { wordBreak: 'break-word', '& p': Object.assign(Object.assign({}, theme.typography.large_bold), { margin: '0 !important', padding: '0 !important' }), [theme.breakpoints.up('md')]: Object.assign(Object.assign({}, theme.typography.xl_bold), { '& p': Object.assign(Object.assign({}, theme.typography.xl_bold), { margin: '0 !important', padding: '0 !important' }) }) }),
        divider: {
            display: 'none',
            [theme.breakpoints.up('md')]: {
                display: 'block',
                width: 1,
                alignSelf: 'stretch',
                flexShrink: 0,
                backgroundColor: '#000000',
                opacity: 0.3,
                marginRight: spacing.medium,
            },
        },
        authorSection: {
            display: 'flex',
            flexDirection: 'row',
            gap: spacing.xs,
            alignItems: 'center',
            [theme.breakpoints.up('md')]: {
                flexShrink: 0,
                gap: spacing.medium,
            },
        },
        authorSectionWithMeta: {
            [theme.breakpoints.up('md')]: {
                width: 417,
            },
        },
        authorImageContainer: {
            flexShrink: 0,
        },
        authorImage: {
            width: 80,
            height: 80,
            borderRadius: '50%',
            objectFit: 'cover',
            display: 'block',
            [theme.breakpoints.up('md')]: {
                width: 120,
                height: 120,
            },
        },
        // Takes available space, pushing image to the end when empty
        authorMeta: {
            display: 'flex',
            flexDirection: 'column',
            gap: 2,
            justifyContent: 'center',
            minWidth: 0,
            flex: 1,
        },
        // Underline applied only when rendered as <a> tag
        authorName: Object.assign(Object.assign({}, theme.typography.small_bold), { textDecoration: 'none', color: 'inherit', '&[href]': {
                textDecoration: 'underline',
                textUnderlinePosition: 'from-font',
            } }),
        locationRow: Object.assign(Object.assign({ display: 'flex', flexWrap: 'wrap', alignItems: 'baseline' }, theme.typography.xxs_regular), { [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.small_regular) }),
        locationPart: {
            display: 'inline-block',
            '&:not(:last-child):after': {
                content: "'|'",
                margin: `0 ${spacing.xxs}`,
                opacity: 0.3,
                userSelect: 'none',
            },
        },
        authorLink: Object.assign(Object.assign({}, theme.typography.xxs_regular), { textDecoration: 'underline', textUnderlinePosition: 'from-font', color: 'inherit', [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.small_regular) }),
        authorLinkText: Object.assign(Object.assign({}, theme.typography.xxs_regular), { textDecoration: 'none', color: 'inherit', [theme.breakpoints.up('md')]: Object.assign({}, theme.typography.small_regular) }),
    };
});
export default useStyles;
